<template>
  <div class="list-group-item" @click="toggleBalInfos(groupKey, item.id)">
    <span v-handle class="handle mr-2"><!-- <i class="fa fa-bars"></i> --></span>
    <slot />
  </div>
</template>
 
<script>
import { ElementMixin, HandleDirective } from 'vue-slicksort';
 
export default {
	props: {
		groupKey: {
      type: String
    },
    item: {
    	type: Object
    }
	},
  mixins: [ElementMixin],
  directives: { handle: HandleDirective },
  methods: {
  	toggleBalInfos(key, balId) {
      this.$root.$emit('bv::toggle::collapse', 'collapse-'+balId)
      // Gestion de la surbrillance de l'entête
      let elements = document.getElementsByClassName('block-'+key)
      for (let element of elements) {
        element.classList.remove("active")
      }

      let item = document.getElementById('item-'+balId)
      this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
        if(collapseId === 'collapse-'+balId && isJustShown) {
          item.classList.add("active")
        }
      })
    },
  }

}
</script>
<style scoped>
.handle {
    display: inline-block;
    float: left;
    width: 18px;
    height: 18px;
    background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50"><path d="M0 7.5v5h50v-5H0zm0 15v5h50v-5H0zm0 15v5h50v-5H0z" color="%23000"/></svg>');
    background-size: contain;
    background-repeat: no-repeat;
    opacity: .25;
    cursor: row-resize;
}
</style>